import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getVenues(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("venues?" + parameters);
  return data;
}

export async function getVenue(id, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("venues/" + id + "?" + parameters);
  return data;
}

export async function createVenue(values) {
  const { data } = await axios.post("venues", values);
  return data;
}

export async function updateVenue(id, values) {
  const { data } = await axios.patch("venues/" + id, values);
  return data;
}

export async function deleteVenue(id) {
  const { data } = await axios.delete("venues/" + id);
  return data;
}
